export default __webpack_public_path__ + "images/XLL.9c7ba6d.png";